import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BreadcrumbPart } from '@ca/core/models';
import { BreadcrumbAndTitleService, ExperimentalFeaturesService } from '@ca/core/services';
import { AppEnvironment } from '@ca/environment/app-environment.enum';
import { environment } from '@ca/environment/environment';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DescriptionTextService } from '../../../shared/components/description-text/description-text.service';
import { BreakpointObserverService } from '../../services/breakpoint-observer.service';
import { UserService } from '../../services/user.service';
import { WindowRef } from '../../services/window.service';
import { WorkflowRunQueueService } from '../../services/workflow-run-queue.service';
import { buildViewModel } from '../../utils/viewmodel';

interface HeaderViewModel {
    breadcrumbParts$: BreadcrumbPart[];
    hasDescriptionText$: boolean;
    isExpanded$: boolean;
    hasActiveWorkflow$: boolean;
    isSmallDevice$: boolean;
}

@UntilDestroy()
@Component({
    selector: 'ca-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    vm$$ = buildViewModel<HeaderViewModel, BreadcrumbPart[] | boolean>({
        breadcrumbParts$: this.breadcrumbAndTitleService.breadcrumbs$,
        hasDescriptionText$: this.descriptionTextService.hasDescriptionText$,
        isExpanded$: this.descriptionTextService.isExpanded$,
        hasActiveWorkflow$: this.workflowRunQueueService.hasRunningWorkflow$,
        isSmallDevice$: this.breakpointObserverService.isSmallDevice$,
    });

    @Output() toggleSidebar = new EventEmitter<boolean>();

    get baseUrl(): string {
        if (environment.type === AppEnvironment.Development) {
            return environment.baseUrl;
        } else {
            return this.windowRef.nativeWindow.location.origin;
        }
    }

    get isLoggedIn(): boolean {
        return this.userService.isLoggedIn;
    }

    get landingPageUrl(): string {
        return environment.landingPageUrl;
    }

    isMEDProjectEnabled = this.experimentalFeaturesService.isMEDProjectActive;
    logoPath = this.isMEDProjectEnabled ? 'assets/images/MED-RDP-logos/logo-RDP-with-padding.svg' : 'assets/images/arivis-cloud-logos/arivis-cloud-logo.svg';
    isLocalhost: boolean = false;

    constructor(
        private breadcrumbAndTitleService: BreadcrumbAndTitleService,
        private breakpointObserverService: BreakpointObserverService,
        private descriptionTextService: DescriptionTextService,
        private userService: UserService,
        private windowRef: WindowRef,
        private workflowRunQueueService: WorkflowRunQueueService,
        private experimentalFeaturesService: ExperimentalFeaturesService,
    ) {}

    ngOnInit(): void {
        this.isLocalhost = this.windowRef.isLocalhost;
    }

    _toggleSidebar(open: boolean): void {
        this.toggleSidebar.emit(open);
    }

    toggleExpanded(): void {
        this.descriptionTextService.toggleExpanded();
    }

    get isLimitCheckingActive(): boolean {
        return this.experimentalFeaturesService.isLimitCheckingActive;
    }
}
